import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './MetricSingleComponent.scss'

const MetricSingleComponent = (props) => {
  const { title, subtitle, theme, number, compact, titlePosition, textAlign } =
    props

  const titleNode = <div className="metric-title">{title}</div>
  const className = classnames(
    'metric-single-component',
    { center: textAlign === 'center' },
    { compact },
    { [`theme-${theme}`]: theme }
  )

  return (
    <div className={className}>
      {titlePosition === 'top' && titleNode}
      <div className="metric-number">{number}</div>
      {titlePosition === 'bottom' && titleNode}
      {subtitle && <div className="metric-subtitle">{subtitle}</div>}
    </div>
  )
}

MetricSingleComponent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  compact: PropTypes.bool,
  titlePosition: PropTypes.oneOf(['top', 'bottom']),
  textAlign: PropTypes.oneOf(['left', 'center']),
  theme: PropTypes.oneOf(['pv-compact']),
}

MetricSingleComponent.defaultProps = {
  titlePosition: 'top',
  textAlign: 'left',
}

export default MetricSingleComponent
